import { render } from "./DashboardOfferDetails.vue?vue&type=template&id=34027bcc&scoped=true"
import script from "./DashboardOfferDetails.vue?vue&type=script&lang=ts"
export * from "./DashboardOfferDetails.vue?vue&type=script&lang=ts"

import "./DashboardOfferDetails.vue?vue&type=style&index=0&id=34027bcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34027bcc"

export default script